import { onValue, ref, remove, update } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";
import CATEGORIES from "../vishisht/categoryConfig";

const STATUS_BADGE = {
  pending: "bg-warning text-dark",
  approved: "bg-success",
  rejected: "bg-danger",
};

const EditModal = ({ record, onClose, onSave }) => {
  const [data, setData] = useState({ ...record.data });
  const category = CATEGORIES.find((c) => c.id === record.categoryId);

  const handleChange = (name, value) => setData((p) => ({ ...p, [name]: value }));

  const handleSave = () => onSave(record.id, data);

  return (
    <div
      className="modal d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-scrollable"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header" style={{ background: "#213F6D", color: "#fff" }}>
            <h5 className="modal-title">✏️ संपादित करें – {record.categoryLabel}</h5>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>
          <div className="modal-body">
            {category?.fields.map((field) => (
              <div className="mb-3" key={field.name}>
                <label className="form-label fw-bold">{field.label}</label>
                {field.type === "textarea" ? (
                  <textarea
                    className="form-control"
                    rows={3}
                    value={data[field.name] || ""}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                  />
                ) : (
                  <input
                    className="form-control"
                    type={field.type}
                    value={data[field.name] || ""}
                    onChange={(e) => handleChange(field.name, e.target.value)}
                  />
                )}
              </div>
            ))}
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              रद्द करें
            </button>
            <button
              className="btn text-white"
              style={{ background: "#213F6D" }}
              onClick={handleSave}
            >
              💾 सहेजें
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const VishishtAdmin = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState("pending");
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => {
    const unsubscribe = onValue(ref(db, "vishisht_panjikaran"), (snap) => {
      if (snap.exists()) {
        const all = Object.entries(snap.val())
          .map(([id, v]) => ({ id, ...v }))
          .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
        setRecords(all);
      } else {
        setRecords([]);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const updateStatus = (id, status) =>
    update(ref(db, `vishisht_panjikaran/${id}`), { status });

  const handleDelete = (id) => {
    if (window.confirm("क्या आप इस रिकॉर्ड को हटाना चाहते हैं?"))
      remove(ref(db, `vishisht_panjikaran/${id}`));
  };

  const handleSaveEdit = (id, data) => {
    update(ref(db, `vishisht_panjikaran/${id}`), { data });
    setEditRecord(null);
  };

  const filtered = records.filter((r) =>
    filterStatus === "all" ? true : r.status === filterStatus
  );

  const counts = {
    all: records.length,
    pending: records.filter((r) => r.status === "pending").length,
    approved: records.filter((r) => r.status === "approved").length,
    rejected: records.filter((r) => r.status === "rejected").length,
  };

  return (
    <div className="container-fluid py-3">
      {editRecord && (
        <EditModal
          record={editRecord}
          onClose={() => setEditRecord(null)}
          onSave={handleSaveEdit}
        />
      )}

      <div className="card shadow-sm">
        <div
          className="card-header d-flex flex-wrap gap-2 align-items-center justify-content-between"
          style={{ background: "#213F6D", color: "#fff" }}
        >
          <h5 className="mb-0">🏅 विशिष्ठ पंजीयन – Admin Panel</h5>
          <div className="d-flex gap-2 flex-wrap">
            {["all", "pending", "approved", "rejected"].map((s) => (
              <button
                key={s}
                className={`btn btn-sm ${filterStatus === s ? "btn-light text-dark" : "btn-outline-light"}`}
                onClick={() => setFilterStatus(s)}
              >
                {s === "all" ? "सभी" : s === "pending" ? "⏳ Pending" : s === "approved" ? "✅ Approved" : "❌ Rejected"}
                <span className="badge bg-secondary ms-1">{counts[s]}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border" style={{ color: "#213F6D" }} />
            </div>
          ) : filtered.length === 0 ? (
            <div className="text-center py-5 text-muted">कोई रिकॉर्ड नहीं मिला।</div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0 align-middle">
                <thead style={{ background: "#f0f4ff" }}>
                  <tr>
                    <th>#</th>
                    <th>श्रेणी</th>
                    <th>नाम / संस्था</th>
                    <th>मोबाइल</th>
                    <th>शहर</th>
                    <th>तिथि</th>
                    <th>स्थिति</th>
                    <th>कार्रवाई</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((r, i) => (
                    <tr key={r.id}>
                      <td>{i + 1}</td>
                      <td>
                        <span className="badge" style={{ background: "#213F6D" }}>
                          {r.categoryLabel}
                        </span>
                      </td>
                      <td className="fw-bold">
                        {r.data?.name || r.data?.orgName || "—"}
                      </td>
                      <td>{r.data?.mobile || "—"}</td>
                      <td>{r.data?.city || "—"}</td>
                      <td>
                        {r.createdAt
                          ? new Date(r.createdAt).toLocaleDateString("hi-IN")
                          : "—"}
                      </td>
                      <td>
                        <span className={`badge ${STATUS_BADGE[r.status] || "bg-secondary"}`}>
                          {r.status}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex gap-1 flex-wrap">
                          {r.status !== "approved" && (
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => updateStatus(r.id, "approved")}
                            >
                              ✅
                            </button>
                          )}
                          {r.status !== "rejected" && (
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => updateStatus(r.id, "rejected")}
                            >
                              ❌
                            </button>
                          )}
                          {r.status === "rejected" && (
                            <button
                              className="btn btn-warning btn-sm"
                              onClick={() => updateStatus(r.id, "pending")}
                            >
                              ↩️
                            </button>
                          )}
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={() => setEditRecord(r)}
                          >
                            ✏️
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => handleDelete(r.id)}
                          >
                            🗑️
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VishishtAdmin;
